import '../assets/css/Footer.scss';
import FooterFeedbackBanner from './FooterFeedbackBanner';
import Auth from '../utils/Auth';
import {
  ACCESSIBILITY_URL,
  GOVUK_URL,
  HELP_URL,
  PRIVACY_URL,
  COOKIES_URL
} from '../constants/AppUrlConstants';

const Footer = () => {
  const isAuthenticated = !!Auth.isAuthorized();
  return (
    <footer>
      {isAuthenticated && <FooterFeedbackBanner />}
      <div className="hods-footer">
        <div className="hods-footer__inner">
          <div className="hods-footer__container hods-width-container">
            <div className="hods-footer__content">
              A Home Office Digital service
            </div>
            <div className="hods-footer__navigation">
              <ul id="navigation" className="hods-footer__navigation-list">
                <li className="hods-footer__navigation-item">
                  <a className="hods-footer__link" href={HELP_URL}>Help</a>
                </li>
                <li className="hods-footer__navigation-item">
                  <a className="hods-footer__link" href={ACCESSIBILITY_URL}>Accessibility</a>
                </li>
                <li className="hods-footer__navigation-item">
                  <a className="hods-footer__link" href={PRIVACY_URL}>Privacy</a>
                </li>
                <li className="hods-footer__navigation-item">
                  <a className="hods-footer__link" href={COOKIES_URL}>Cookies</a>
                </li>
                <li className="hods-footer__navigation-item">
                  <a className="hods-footer__link" href={GOVUK_URL}>GOV.UK</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
